// ImageWithBlur.jsx

import React, { useState, useRef } from "react";
import { Box, Skeleton } from "@mui/material";
import { isMobile } from "react-device-detect";

const ImageWithBlur = ({ src, alt, width, height }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const isDesktop = !isMobile;

  // Resetear estado solo cuando src CAMBIA (no en mount inicial)
  const prevSrcRef = useRef(src);
  if (prevSrcRef.current !== src) {
    setImageLoaded(false);
    setImageError(false);
    prevSrcRef.current = src;
  }

  const containerStyle = {
    position: "relative",
    width: width || (isDesktop ? "200px" : "100%"),
    height: height || (isDesktop ? "150px" : "45vw"),
    borderRadius: 2,
    overflow: "hidden",
    backgroundColor: "#f5f5f5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  const blurBackgroundStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `url(${src})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    filter: "blur(10px)",
    transform: "scale(1.1)",
    zIndex: 1
  };

  const mainImageStyle = {
    position: "relative",
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
    zIndex: 2,
    display: imageLoaded && !imageError && src ? "block" : "none"
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageLoaded(false);
    setImageError(true);
  };

  return (
    <Box sx={containerStyle}>
      {/* Imagen de fondo con blur - solo mostrar si hay src, no hay error y está cargada */}
      {src && !imageError && imageLoaded && (
        <Box sx={blurBackgroundStyle} />
      )}
      
      {/* Imagen principal */}
      {src && (
        <img
          src={src}
          alt={alt}
          style={mainImageStyle}
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
      )}
      
      {/* Skeleton loader cuando: no hay imagen (src null), está cargando, o hay error */}
      {(!src || (!imageLoaded && src) || imageError) && (
        <>
          {/* Contenedor con fondo sólido para bloquear el blur */}
          <Box 
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "#f5f5f5",
              zIndex: 3
            }}
          />
          
          {/* Skeleton SIN backgroundColor para que se vea la animación */}
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            height="100%"
            animation="wave"
            sx={{ 
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 4
            }} 
          />
        </>
      )}
    </Box>
  );
};

export default ImageWithBlur;
